import React, { Component } from 'react'
import { func, shape, number } from 'prop-types'
import { translate } from 'react-i18next'
import { PaymentDescription } from './PaymentDescription'
import { stores } from '../../stores'

class ByCardComponent extends Component {
  constructor () {
    super()
    this.state = { loading: false }
  }

  get disabled () {
    return this.state.loading
  }

  submit () {
    if (this.disabled) { return }
    this.setState({ loading: true })
    stores.inquiries.accept({ mean: 'card' })
  }

  render () {
    const { t, payment } = this.props

    return (<div>
      <PaymentDescription cards payment={payment} />
      <div className='paiement__body__validate'>
        <button
          className={`${!this.disabled ? 'btn--green' : 'btn--disabled'} layout--centered`}
          onClick={() => this.submit()}
          >{t('common:buttons:pay')}</button>
      </div>
    </div>)
  }
}

ByCardComponent.propTypes = {
  t: func,
  payment: shape({
    advance: number,
    unpaid: number,
    total: number,
    balance: number
  })
}

export const ByCard = translate()(ByCardComponent)



// WEBPACK FOOTER //
// ./src/components/payment/ByCard.js